SingleProduct.controller( 'VariationsCtrl', [ '$scope', 'DATA', 'VariationsSrv', function( $scope, DATA, VariationsSrv ){
	var self = this;
	VariationsSrv.initCurrents();
	VariationsSrv.filterVariations();
	this.chosenVariations = [];
	this.addMore = false
	this.boxSizes = VariationsSrv.getBoxSizes();
	this.finishings = VariationsSrv.getFinishings();
	this.def_colors = VariationsSrv.getDefColor();
	this.basket = [];
	this.finishing = ''
	this.package = ''
	this.is_def_color = false
	this.def_color = ''
	this.price = 0
	this.current_variation = null
	this.current_qty = 1


	$scope.$watch(function(){return self.current_variation;}, function( current_variation ){
		self.current_variation = current_variation;
		self.addMore = self.current_variation
		calculatePrice()
	})

	$scope.$watch(function(){return self.current_qty;}, function( qty ){
		self.current_qty = qty
		self.current_variation = VariationsSrv.setChosenVariation( self.current_qty );
		calculatePrice()
	})





	this.removeFromBasket = function ( item ) {
		var itemIndex = this.basket.indexOf(item)
		this.basket.splice(itemIndex, 1)
		VariationsSrv.basket.splice(itemIndex, 1)
		calculatePrice()
	}

	this.addToBasket = function () {
		VariationsSrv.addItem( this.current_qty )
		this.basket = VariationsSrv.basket.map(function( item ){
			var attrSizeUnit = item.variation.attributes.hasOwnProperty('attribute_pa_liter') ? 'attribute_pa_liter' :  'attribute_pa_kilogram',
				size = parseFloat( item.variation.attributes[ attrSizeUnit ] );

			return {
					price: item.price,
					qty: item.qty,
					unit: attrSizeUnit === 'attribute_pa_kilogram' ? 'ק"ג' : ( attrSizeUnit === 'attribute_pa_liter' && size < 1 ) ? 'מיל\'' : 'ליטר',
					size: size
				}
		})
		this.current_variation = null
		calculatePrice()
		this.resetFields()
	}


	this.toggleDefColor = function ( color ) {
		this.def_color = color
		VariationsSrv.toggleDefColor( this.is_def_color, color )
		this.boxSizes = VariationsSrv.getBoxSizes();
	}

	this.setBoxSize = function( package ) {
		VariationsSrv.setBoxSize( package );
		this.finishings = VariationsSrv.getFinishings();
		this.def_colors = VariationsSrv.getDefColor();
		this.current_variation = VariationsSrv.setChosenVariation( this.current_qty );

		this.addMore = this.current_variation;

	}

	this.setFinishing = function( finishing ) {
		VariationsSrv.setFinishing( finishing );
		this.boxSizes = VariationsSrv.getBoxSizes();
		this.def_colors = VariationsSrv.getDefColor();
		this.current_variation = VariationsSrv.setChosenVariation( this.current_qty );

		this.addMore = this.current_variation;
	}

	this.setDefColor = function ( defColor ) {
		VariationsSrv.setDefColor( defColor );
		this.boxSizes = VariationsSrv.getBoxSizes();
		this.finishings = VariationsSrv.getFinishings();
		this.current_variation = VariationsSrv.setChosenVariation( this.current_qty );

		this.addMore = this.current_variation;
	}


	this.resetFields = function() {
		this.finishing = ''
		this.package = ''
		this.current_qty = 1
		this.price = 0
		if( this.is_def_color && this.def_color ) {
			VariationsSrv.toggleDefColor( this.is_def_color, this.def_color )
		}
	}


	this.resetData = function () {
		this.current_variation = null
		this.basket = []
	}

	function calculatePrice () {
		self.price = 0;

		if( self.basket.length ) {
			self.price = self.basket.map(function(item){
				return item.price;
			}).reduce( function(a,b) {
				return a+b;
			});
		}
		if( self.current_variation ) {
			self.price += self.current_variation.price
		}

		self.price = self.price.toFixed(2)
	}

}])